"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledReadOnlySelect = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Select = require("../Select/Select");
var StyledReadOnlySelect = /*#__PURE__*/(0, _styledComponents.default)(_Select.Select).withConfig({
  displayName: "StyledReadOnlySelect",
  componentId: "c11n-8-107-0__sc-219df2-0"
})([""]);
exports.StyledReadOnlySelect = StyledReadOnlySelect;